import { App, AppInfo } from '@capacitor/app';
import { supabase } from '../supabase';
import { Capacitor } from '@capacitor/core';

class AppUpdateService {
    constructor() {}

    private _appInfo: AppInfo | null = null;
    private _minimumVersion: string | null = null;
    
    async getAppInfo(): Promise<AppInfo> {
        if (this._appInfo === null) {
            this._appInfo = await App.getInfo();
        }
        return this._appInfo;
    }

    async getMinimumVersion() : Promise<string | null>  {

    if (Capacitor.isNativePlatform()) {
      const platform = Capacitor.getPlatform();
     console.log(platform);
        const { data, error } = await supabase
          .from('sys_params_lu')
          .select('param_desc, param_value')
          .filter('param_desc', 'in', '("minimum_ios","minimum_android")');

        if (error) {
          console.error('Error fetching minimum version:', error);
          return null;
        }
        console.log('Minimum version data:', data);

        if (platform === 'android') {
          this._minimumVersion = data.filter((item) => item.param_desc === 'minimum_android').map((item) => item.param_value)[0] || null;
        } else if (platform === 'ios') {
          this._minimumVersion = data.filter((item) => item.param_desc === 'minimum_ios').map((item) => item.param_value)[0] || null;
        }
    }
        return this._minimumVersion;
    }
}

export const appUpdateService = new AppUpdateService();